export const dietTagCreateToJSON = (json: IDietTagCreatePayload): Partial<IDietDietaryTag> => {
	const { name, modelType } = json

	return {
		model_type: modelType ? modelType : undefined,
		name: name ? generateLangContentArray(name) : undefined,
	}
}

export const dietTagUpdateToJSON = (
	payload: IDietTagUpdatePayload,
	updated: IDietFilterTagModel | IDietMarketingTagModel | IDietDietaryTagModel,
): IDietDietaryTag => {
	const { name: updatedName, modelType } = payload

	const { id, name } = updated

	return {
		id,
		name: LangContentToJson(name, updatedName),
		model_type: modelType ? modelType : undefined,
	}
}

export const DietFilterTag = (json: IDietFilterTag): IDietFilterTagModel => {
	const fromJSON = (itemJson: IDietFilterTag) => {
		const { name, model_type, ...rest } = itemJson
		return {
			name: LangContentToModel(name),
			modelType: model_type,
			kind: 'filter' as const,
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const dietFilterTagToJSON = (obj: Partial<IDietFilterTagModel>): Partial<IDietFilterTag> => {
	const { name, modelType, ...rest } = obj
	return {
		model_type: modelType,
		name: name ? generateLangContentArray(name.pl) : [],
		...rest,
	}
}

export const DietMarketingTag = (json: IDietMarketingTag): IDietMarketingTagModel => {
	const fromJSON = (itemJson: IDietMarketingTag) => {
		const { name, model_type, ...rest } = itemJson
		return {
			name: LangContentToModel(name),
			modelType: model_type,
			kind: 'marketing' as const,
			...rest,
		}
	}

	return { ...fromJSON(json) }
}

export const dietMarketingTagToJSON = (obj: Partial<IDietMarketingTagModel>): Partial<IDietMarketingTag> => {
	const { name, modelType, ...rest } = obj
	return {
		model_type: modelType,
		name: name ? generateLangContentArray(name.pl) : [],
		...rest,
	}
}

export const DietDietaryTag = (json: IDietDietaryTag): IDietDietaryTagModel => {
	const { name, ...rest } = json

	return {
		name: LangContentToModel(name),
		kind: 'dietary',
		...rest,
	}
}
